<div class="confirm-container">
  <span mat-dialog-title>Resurrect Deal</span>
  <div mat-dialog-content>
    <div><b>Are you sure you want to resurrect the deal?</b></div>

    <div class="warning-message"><mat-icon color="primary">info</mat-icon> Statuses will be editable once the deal is resurrected.</div>

    @if (dealInfo) {
      <ul>
        <li>
          <b>Deal: </b>{{dealInfo.deal}}
        </li>
        @if (dealInfo.developer) {
          <li>
            <b>Developer: </b>{{dealInfo.developer}}
          </li>
        }
        <li>
          <b>Closing Status: </b>{{dealInfo.closingStatus ? dealInfo.closingStatus : "None"}}
        </li>
      </ul>
    }
  </div>

  <div mat-dialog-actions style="float:right;margin:20px;">
    <button mat-button [mat-dialog-close]="{ clicked: 'Ok' }">Ok</button>
    <button mat-button [mat-dialog-close]="{ clicked: 'Cancel' }">
      Cancel
    </button>
  </div>
</div>
